import { FormlyFieldConfig } from '@ngx-formly/core';

export const GiuridicaStep: FormlyFieldConfig[] = [
    {
        fieldGroupClassName:
            'border border-t-4 p-4 shadow-sm rounded-xl grid md:grid-cols-12 sm:grid-cols-1 gap-2',
        fieldGroup: [
            {
                className: 'md:col-span-6 sm:col-span-1',
                key: 'intestatario.giuridica.qualita',
                type: 'mat-select',
                props: {
                    label: 'IN QUALITÀ DI',
                    required: true,
                    options: [
                        { value: null, label: '' },
                        { value: 'Amministratore', label: 'Amministratore' },
                        {
                            value: 'Legale Rappresentante',
                            label: 'Legale Rappresentante',
                        },
                        {
                            value: 'Ditta Individuale',
                            label: 'Ditta Individuale',
                        },
                        { value: 'Altro', label: 'Altro' },
                    ],
                }
            },
            {
                className: 'md:col-span-6 sm:col-span-1',
                key: 'intestatario.giuridica.denominazione',
                type: 'mat-input',
                props: {
                    label: 'DENOMINAZIONE/RAGIONE SOCIALE',
                    required: true,
                }
            },
            {
                className: 'md:col-span-4 sm:col-span-1',
                key: 'intestatario.giuridica.piva',
                type: 'mat-input',
                props: {
                    label: 'PARTITA IVA',
                    maxLength: 11,
                    required: true,
                },
                validators: {
                    validation: ['p_iva'],
                }
            },

            {
                className: 'md:col-span-3 sm:col-span-1',
                key: 'intestatario.giuridica.cf',
                type: 'mat-input',
                props: {
                    label: 'CODICE FISCALE',
                    maxLength: 16,
                    required: true
                },
            },
            {
                className: 'md:col-span-3 sm:col-span-1',
                key: 'intestatario.giuridica.comune_dict',
                type: '#autocomplete-comune',
                props: {
                    label: 'COMUNE SEDE',
                    "required": true,
                },
            },
            {
                className: 'md:col-span-2 sm:col-span-1',
                key: 'intestatario.giuridica.cap',
                type: 'mat-input',
                "props": {
                    "label": 'CAP',
                    "required": true,
                    "pattern": '^[0-9]{5}$'
                },
                "validation": {
                    "show": true,
                    "messages": {
                    "pattern": "Il CAP deve essere di 5 cifre numeriche"
                    }
                }
            },
            {
                className: 'md:col-span-5 sm:col-span-1',
                key: 'intestatario.giuridica.indirizzo',
                type: 'mat-input',
                props: {
                    label: 'INDIRIZZO',
                    required: true,
                }
            },
            {
                className: 'md:col-span-3 sm:col-span-1',
                key: 'intestatario.giuridica.civico',
                type: 'mat-input',
                props: {
                    label: 'CIVICO',
                    required: true,
                }
            },
            {
                className: 'md:col-span-4 sm:col-span-1',
                key: 'intestatario.giuridica.loc',
                type: 'mat-input',
                props: {
                    label: 'LOCALITÀ ESTERA',
                    // required:true
                }
            },
            {
                className: 'md:col-span-6 sm:col-span-1',
                key: 'intestatario.giuridica.email',
                type: '#email',
            },
            {
                className: 'md:col-span-6 sm:col-span-1',
                key: 'intestatario.giuridica.pec',
                type: '#email',
                "props": {
                    "label": 'PEC',
                }
            },
            {
                className: 'md:col-span-4 sm:col-span-1 font-sans',
                key: 'intestatario.giuridica.cellulare',
                type: 'mat-input',
                props: {
                    label: 'CELLULARE',
                }
            },
            {
                className: 'md:col-span-4 sm:col-span-1 font-sans',
                key: 'intestatario.giuridica.telefono',
                type: 'mat-input',
                props: {
                    label: 'TELEFONO',
                }
            },
            {
                className: 'md:col-span-4 sm:col-span-1',
                key: 'intestatario.giuridica.fax',
                type: 'mat-input',
                props: {
                    label: 'FAX',
                }
            },
        ],
        expressions: {
            hide: "(model.intestatario?.tipo == 'fisica')",
        },
    },
];
